import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MailAccountsService } from './mail-accounts.service';
import { MailAccountModel } from './mail-account.model';
import { ConnectMailAccountDialogComponent } from './connect-mail-account-dialog.component';
import { DialogsService } from '../../../shared/components/dialogs/dialogs.service';

@Component({
  selector: 'app-correos-ia',
  templateUrl: './correos-ia.component.html',
  styleUrls: ['./correos-ia.component.css'],
  standalone: false,
})
export class CorreosIAComponent implements OnInit {

  displayedColumns: string[] = ['email', 'estado', 'ultimaComprobacion', 'acciones'];
  cuentas: MailAccountModel[] = [];
  loading = true;
  runningNow: { [uid: string]: boolean } = {};

  constructor(
    private mailAccountsService: MailAccountsService,
    public dialog: MatDialog,
    private dialogService: DialogsService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.loading = true;
    this.mailAccountsService.getList().then(cuentas => {
      this.cuentas = cuentas;
      this.loading = false;
    });
  }

  conectar(): void {
    const dialogRef = this.dialog.open(ConnectMailAccountDialogComponent, {
      width: '480px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cargar();
      }
    });
  }

  cambiarActivo(cuenta: MailAccountModel): void {
    const nuevoEstado = !cuenta.active;
    this.mailAccountsService.toggleActive(cuenta.uid, nuevoEstado).then(
      () => { cuenta.active = nuevoEstado; },
      () => { this.snackBar.open('No se pudo cambiar el estado del buzón.', 'Cerrar', { duration: 4000 }); }
    );
  }

  comprobarAhora(cuenta: MailAccountModel): void {
    this.runningNow[cuenta.uid] = true;
    this.mailAccountsService.runNow(cuenta.uid).then(
      actualizada => {
        this.runningNow[cuenta.uid] = false;
        cuenta.lastCheckedAt = actualizada.lastCheckedAt;
        cuenta.lastError = actualizada.lastError;
        this.snackBar.open('Comprobación completada.', 'Cerrar', { duration: 3000 });
      },
      () => {
        this.runningNow[cuenta.uid] = false;
        this.snackBar.open('No se pudo comprobar el buzón ahora mismo.', 'Cerrar', { duration: 4000 });
      }
    );
  }

  desconectar(cuenta: MailAccountModel): void {
    this.dialogService.confirm('Desconectar correo', `¿Seguro que quieres desconectar ${cuenta.email}? Dejará de analizarse el correo entrante.`)
      .subscribe(confirmado => {
        if (confirmado) {
          this.mailAccountsService.delete(cuenta.uid).then(() => this.cargar());
        }
      });
  }
}
